import one from '../images/c1.jpg'
import two from '../images/c2.jpg'
import three from '../images/c3.jpg'
import four from '../images/c4.jpg'

function Footer() {
    return (
        <div class="cls6">
            <h1>Most Popular</h1>
            <p>pick the best fit</p>
            <div class="cls6_1">
                <div class="main4_1">
                    <img src={one} alt='one'/>
                        <h3>2023 Python Data Visualization Masterclass</h3>
                        <p>col steel</p>
                        <p>4.8 <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star"
                            style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i
                                class="fa-solid fa-star" style={{color: '#FFD43B'}}></i></p>
                        <p><i class="fa-solid fa-indian-rupee-sign" style={{color: '#1f1f1f'}}></i>449 <del>1999</del></p>
                </div>

                <div class="main4_1">
                    <img src={two} alt='one'/>
                        <h3>2023 Python Data Visualization Masterclass</h3>
                        <p>col steel</p>
                        <p>2.8 <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star"
                            style={{color: '#FFD43B'}}></i></p>
                        <p><i class="fa-solid fa-indian-rupee-sign" style={{color: '#1f1f1f'}}></i>449 <del>1999</del></p>
                </div>

                <div class="main4_1">
                    <img src={three} alt='one'/>
                        <h3>2023 Python Data Visualization Masterclass</h3>
                        <p>col steel</p>
                        <p>4.0<i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star"
                            style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i
                                class="fa-solid fa-star" style={{color: '#FFD43B'}}></i></p>
                        <p><i class="fa-solid fa-indian-rupee-sign" style={{color: '#1f1f1f'}}></i>449 <del>1999</del></p>
                </div>

                <div class="main4_1">
                    <img src={four} alt='one'/>
                        <h3>2023 Python Data Visualization Masterclass</h3>
                        <p>col steel</p>
                        <p>3.8 <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star"
                            style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i></p>
                        <p><i class="fa-solid fa-indian-rupee-sign" style={{color: '#1f1f1f'}}></i>449 <del>1999</del></p>
                </div>

                <div class="main4_1">
                    <img src={one} alt='one'/>
                        <h3>2023 Python Data Visualization Masterclass</h3>
                        <p>col steel</p>
                        <p>4.8 <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star"
                            style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i
                                class="fa-solid fa-star" style={{color: '#FFD43B'}}></i></p>
                        <p><i class="fa-solid fa-indian-rupee-sign" style={{color: '#1f1f1f'}}></i>449 <del>1999</del></p>
                </div>

                <div class="main4_1">
                    <img src={two} alt='one'/>
                        <h3>2023 Python Data Visualization Masterclass</h3>
                        <p>col steel</p>
                        <p>2.8 <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star"
                            style={{color: '#FFD43B'}}></i></p>
                        <p><i class="fa-solid fa-indian-rupee-sign" style={{color: '#1f1f1f'}}></i>449 <del>1999</del></p>
                </div>

                <div class="main4_1">
                    <img src={three} alt='one'/>
                        <h3>2023 Python Data Visualization Masterclass</h3>
                        <p>col steel</p>
                        <p>4.0<i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star"
                            style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i
                                class="fa-solid fa-star" style={{color: '#FFD43B'}}></i></p>
                        <p><i class="fa-solid fa-indian-rupee-sign" style={{color: '#1f1f1f'}}></i>449 <del>1999</del></p>
                </div>

                <div class="main4_1">
                    <img src={four} alt='one'/>
                        <h3>2023 Python Data Visualization Masterclass</h3>
                        <p>col steel</p>
                        <p>3.8 <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star"
                            style={{color: '#FFD43B'}}></i> <i class="fa-solid fa-star" style={{color: '#FFD43B'}}></i></p>
                        <p><i class="fa-solid fa-indian-rupee-sign" style={{color: '#1f1f1f'}}></i>449 <del>1999</del></p>
                </div>
            </div>
        </div>
    )
}

export default Footer